(function () {
  function qs(selector, root = document) {
    return root.querySelector(selector);
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function initCart() {
    qsa(".js-erk-cart-open").forEach((button) => {
      button.addEventListener("click", () => {
        const drawer = qs("cart-drawer");
        if (drawer && typeof drawer.open === "function") {
          drawer.open(button);
          return;
        }
        window.location.href = window.routes?.cart_url || "/cart";
      });
    });
  }

  function initQuest() {
    qsa(".js-erk-quest").forEach((stage) => {
      const button = qs(".js-erk-quest-start", stage);
      if (!button) return;

      let bottleTimer = null;
      let resetTimer = null;

      button.addEventListener("click", () => {
        if (stage.classList.contains("active")) return;

        stage.classList.add("active");
        stage.classList.remove("is-bottle-ready");

        window.clearTimeout(bottleTimer);
        window.clearTimeout(resetTimer);

        bottleTimer = window.setTimeout(() => {
          stage.classList.add("is-bottle-ready");
        }, 3000);

        resetTimer = window.setTimeout(() => {
          stage.classList.remove("active", "is-bottle-ready");
        }, 7200);
      });
    });
  }

  function openDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === "function") {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
    }
  }

  function initProduct(root = document) {
    qsa(".js-erk-product", root).forEach((productRoot) => {
      initProductRoot(productRoot);
    });
  }

  function initProductRoot(root) {
    if (!root || root.dataset.erkProductInitialized === "true") return;
    root.dataset.erkProductInitialized = "true";

    const variantInput = qs('input[name="id"]', root);
    const addLabel = qs(".js-erk-add-label", root);
    const submitButton = qs('[type="submit"][name="add"]', root);
    const priceLabel = qs(".js-erk-price", root);
    const hero = qs(".js-erk-product-hero", root);
    const slides = qsa(".js-erk-slide", root);
    const prevButton = qs(".js-erk-gallery-prev", root);
    const nextButton = qs(".js-erk-gallery-next", root);
    const galleryCount = qs(".js-erk-gallery-count", root);
    const variantsScript = qs(".js-erk-variants", root);
    const detailsOpenButton = qs(".js-erk-details-open", root);
    const detailsModal = qs(".js-erk-details-modal", root);
    const detailsCloseButton = qs(".js-erk-details-close", root);
    let activeMediaIndex = 0;
    let variants = [];

    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent || "[]") : [];
    } catch (error) {
      variants = [];
    }

    function setGalleryIndex(index) {
      if (!hero || !slides.length) return;
      activeMediaIndex = (index + slides.length) % slides.length;
      const slide = slides[activeMediaIndex];
      hero.src = slide.dataset.src || hero.src;
      hero.alt = slide.dataset.alt || hero.alt;
      slides.forEach((other) => other.classList.toggle("is-active", other === slide));
      if (galleryCount) galleryCount.textContent = `${activeMediaIndex + 1} / ${slides.length}`;
    }

    prevButton?.addEventListener("click", () => setGalleryIndex(activeMediaIndex - 1));
    nextButton?.addEventListener("click", () => setGalleryIndex(activeMediaIndex + 1));

    detailsOpenButton?.addEventListener("click", () => {
      openDialog(detailsModal);
    });

    detailsCloseButton?.addEventListener("click", () => {
      closeDialog(detailsModal);
    });

    detailsModal?.addEventListener("click", (event) => {
      if (event.target !== detailsModal) return;
      closeDialog(detailsModal);
    });

    function getSelectedOptions() {
      const selected = [];
      qsa(".js-erk-option-value.is-active", root).forEach((button) => {
        const position = Number(button.dataset.optionPosition || 0);
        if (position) selected[position - 1] = button.dataset.optionValue || "";
      });
      return selected;
    }

    function findSelectedVariant() {
      const selected = getSelectedOptions();
      return variants.find((variant) => {
        return Array.isArray(variant.options) && variant.options.every((option, index) => option === selected[index]);
      });
    }

    function updateSelectedVariant(variant) {
      const available = Boolean(variant?.available);

      if (variantInput) {
        variantInput.value = variant?.id || "";
        variantInput.disabled = !available;
      }
      if (priceLabel && variant?.price) priceLabel.textContent = variant.price;
      if (addLabel) {
        addLabel.textContent = available && variant?.price ? `Add to Cart - ${variant.price}` : window.variantStrings?.soldOut || "Sold out";
      }
      if (submitButton) {
        submitButton.disabled = !available;
        submitButton.toggleAttribute("aria-disabled", !available);
      }
    }

    qsa(".js-erk-option-value", root).forEach((button) => {
      button.addEventListener("click", () => {
        const position = button.dataset.optionPosition;
        qsa(`.js-erk-option-value[data-option-position="${position}"]`, root).forEach((other) => {
          other.classList.toggle("is-active", other === button);
        });
        updateSelectedVariant(findSelectedVariant());
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initCart();
    initQuest();
    initProduct();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initProduct(event.target);
  });
})();
